import { useContext, useState } from 'react';
import {
  MenuItem,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Switch,
  FormControlLabel,
  FormLabel,
  Button,
  Alert,
} from '@mui/material';

import { AuthContext } from 'components';
import {
  SpinnerIcon
} from 'components/Icons';


export const PrintModal = (props) => {
  const { items, selected } = props;
  const [ open, setOpen ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState("");
  const [ includeCostPrice, setIncludeCostPrice ] = useState(false);
  const [ includeRetailPrice, setIncludeRetailPrice ] = useState(false);
  const [ includeQuantity, setIncludeQuantity ] = useState(false);
  const [ includeMarkup, setIncludeMarkup ] = useState(false);
  const [ includeDelivery, setIncludeDelivery ] = useState(false);
  const [ includeOrderNumber, setIncludeOrderNumber ] = useState(false);
  const [ includeNotes, setIncludeNotes ] = useState(false);
  const [ printLink, setPrintLink ] = useState(null);
  const { printStyles } = useContext(AuthContext)

  const handleOpen = () => {
    setOpen(true);
    setPrintLink(null);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleAction = () => {
    setLoading(true);
    setError(false);
    if (!selected) {
      return
    }
    
    const itemIds = items.map(e => e.id)
    printStyles(
      itemIds, 
      {
        costPrice: includeCostPrice,
        retailPrice: includeRetailPrice,
        quantity: includeQuantity,
        markup: includeMarkup,
        delivery: includeDelivery,
        orderNumber: includeOrderNumber,
        notes: includeNotes,
      }, 
      (data) => {
        if (data.url) {
          window.open(data.url, '_blank')?.focus();
        } else {
          console.log('error', data)
          setError("Oops! Unexpected error printing styles. Please contact support@thefavesapp.com for assistance.")
        }
        setPrintLink(data.url)
        setLoading(false);
      }
    )
  };
 
  return (
    <>
      <MenuItem onClick={handleOpen} component="div" disabled={!selected || loading} color="warning" aria-label="add">
        {/* <PrintIcon onClick={handleAction} /> */}
        { loading ? (
          <div>
            <Typography component="span">Print</Typography>
            <SpinnerIcon 
              sx={{
                position: 'relative',
                top: 2,
              }}
              fontSize='8'
            />
          </div>
        ) : (
          <div>Print</div>
        ) }
      </MenuItem>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          Include optional information
        </DialogTitle>
        
        <DialogContent>
          <DialogContentText>
            <FormControlLabel componentsProps={{ typography: { sx: { flexGrow: 1, textAlign: 'left' } }}} value="start" labelPlacement="start" label="Cost Price" sx={{ width: "100%", marginLeft: 0 }}
              control={<Switch value={includeCostPrice} onChange={(e) => { setIncludeCostPrice(!includeCostPrice) }} color="primary" />}
            />
          </DialogContentText>

          <DialogContentText>
            <FormControlLabel componentsProps={{ typography: { sx: { flexGrow: 1, textAlign: 'left' } }}} value="start" labelPlacement="start" label="Retail Price" sx={{ width: "100%", marginLeft: 0 }}
              control={<Switch value={includeRetailPrice} onChange={(e) => { setIncludeRetailPrice(!includeRetailPrice) }} color="primary" />}
            />
          </DialogContentText>
          
          <DialogContentText>
            <FormControlLabel componentsProps={{ typography: { sx: { flexGrow: 1, textAlign: 'left' } }}} value="start" labelPlacement="start" label="Markup" sx={{ width: "100%", marginLeft: 0 }}
              control={<Switch value={includeMarkup} onChange={(e) => { setIncludeMarkup(!includeMarkup) }} color="primary" />}
            />
          </DialogContentText>

          <DialogContentText>
            <FormControlLabel componentsProps={{ typography: { sx: { flexGrow: 1, textAlign: 'left' } }}} value="start" labelPlacement="start" label="Quantity" sx={{ width: "100%", marginLeft: 0 }}
              control={<Switch value={includeQuantity} onChange={(e) => { setIncludeQuantity(!includeQuantity) }} color="primary" />}
            />
          </DialogContentText>

          <DialogContentText>
            <FormControlLabel componentsProps={{ typography: { sx: { flexGrow: 1, textAlign: 'left' } }}} value="start" labelPlacement="start" label="Delivery" sx={{ width: "100%", marginLeft: 0 }}
              control={<Switch value={includeDelivery} onChange={(e) => { setIncludeDelivery(!includeDelivery) }} color="primary" />}
            />
          </DialogContentText>

          <DialogContentText>
            <FormControlLabel componentsProps={{ typography: { sx: { flexGrow: 1, textAlign: 'left' } }}} value="start" labelPlacement="start" label="Order Number" sx={{ width: "100%", marginLeft: 0 }}
              control={<Switch value={includeOrderNumber} onChange={(e) => { setIncludeOrderNumber(!includeOrderNumber) }} color="primary" />}
            />
          </DialogContentText>

          <DialogContentText>
            <FormControlLabel componentsProps={{ typography: { sx: { flexGrow: 1, textAlign: 'left' } }}} value="start" labelPlacement="start" label="Notes" sx={{ width: "100%", marginLeft: 0 }}
              control={<Switch value={includeNotes} onChange={(e) => { setIncludeNotes(!includeNotes) }} color="primary" />}
            />
          </DialogContentText>
        </DialogContent>

        { loading || printLink ? (
          <DialogContent>
            <DialogContentText>
              { printLink ? (
                <FormLabel>Your browser might be blocking pop-ups. If a new window hasn't opened, click <a href={printLink} target="_blank">here</a>.</FormLabel>
              ) : (
                <FormLabel>Working…</FormLabel>
              ) }
            </DialogContentText>
          </DialogContent>
        ) : null }

        {error ? (<Alert severity="warning">{error}</Alert>) : null}

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={loading} onClick={handleAction} autoFocus>Print</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}